<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-shake-device`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M30.255 1.978l.109.102L45.92 17.636c.746.746.777 1.936.102 2.72l-.102.108L20.464 45.92a2.003 2.003 0 01-2.718.102l-.11-.102L2.08 30.364a2.003 2.003 0 01-.102-2.72l.102-.108L27.536 2.08a2.003 2.003 0 012.718-.102zM28.95 6.322L6.322 28.95 19.05 41.678 41.678 19.05 28.95 6.322zm13.702 20.963c.177.053.324.135.64.45l1.015 1.015c.315.316.396.463.45.64a.908.908 0 010 .534c-.054.177-.135.324-.45.64l-9.501 9.5c-.315.315-.462.397-.64.45a.909.909 0 01-.534 0c-.177-.053-.324-.135-.639-.45l-1.016-1.015c-.315-.316-.396-.463-.45-.64a.909.909 0 010-.534c.054-.177.135-.324.45-.64l9.501-9.5c.316-.315.463-.397.64-.45a.909.909 0 01.534 0zm-24.309 2.372A3 3 0 1114.1 33.9a3 3 0 014.243-4.243zm.267-26.414c.155.047.287.115.529.343l1.126 1.123c.315.315.397.462.45.639a.909.909 0 010 .535c-.053.176-.135.323-.45.639l-9.5 9.5c-.316.316-.463.397-.64.45a.909.909 0 01-.534 0c-.177-.053-.324-.134-.64-.45l-1.015-1.015c-.315-.315-.397-.462-.45-.64a.909.909 0 010-.534c.047-.155.115-.287.342-.528l9.609-9.612c.315-.315.462-.396.639-.45a.909.909 0 01.534 0z"/></svg>
</template>
<script>

export default {
  name: 'IconShakeDevice',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
